import {
  COMPANY_PERSONAL_STRUCTURE_TYPES,
  VERIFICATION_PROCESS_TYPES,
  VERIFICATION_STATES,
} from '@/constants'
import type { UserMeOrganization } from '@deepcloud/api-deep-admin'

export function isPersonalOrganizationNoBox(org: UserMeOrganization) {
  if (!org) return null

  return (
    org?.structure &&
    COMPANY_PERSONAL_STRUCTURE_TYPES.includes(org?.structure) &&
    org?.verification_state === VERIFICATION_STATES.VERIFICATION_STATE_NONE &&
    (org?.verification_process_status === null ||
      org?.verification_process_status ===
        VERIFICATION_PROCESS_TYPES.VERIFICATION_PROCESS_TYPE_STARTED)
  )
}
